import(/* webpackMode: "eager" */ "/work/apps/frontend/src/app/(auth)/login/error.tsx");
